<template>
  <div id="card">
    <div id="sub-card">
      <object v-if="showImage" id="image" :data="getMediaItem()" type="image/png">
        <img id="image" src="img/no-image.png" alt="" />
      </object>

      <div id="sub-card-content" style="text-align: center; text-justify: center">
        <div id="heading">{{ label }}</div>
      </div>

    </div>

    <div id="card-actions">
      <div class="card-action">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="card-action">
              <v-icon v-bind="attrs" v-on="on" class="card-icon" size="30" color="white" @click="ctrl.delete(item)">
                mdi-close</v-icon>
            </div>
          </template>
          <span>{{ deleteWholeItemTt }}</span>
        </v-tooltip>
      </div>
      <div id="card-action">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="card-action">
              <v-icon v-bind="attrs" v-on="on" class="card-icon" size="30" color="white" @click="ctrl.onEdit(item)">
                mdi-book-edit</v-icon>
            </div>
          </template>
          <span>{{ editTt }}</span>
        </v-tooltip>
      </div>

      <div class="card-action">
        <v-menu  rounded="xl">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense shaped subheader> 
             <v-subheader class="pl-5">Media Actions</v-subheader>
            <v-list-item @click="openfileTitleDialog()">
              <v-list-item-icon>
                <v-icon class="card-icon" size="30">
                  mdi-image</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ changeMediaTt }}
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="deleteIMG()">
              <v-list-item-icon>
                <v-icon  class="card-icon" size="30">
                  mdi-delete
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ deleteMediaTt }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <input accept="*" ref="FileBackGround" @change="uploadtitleImage" type="file" style="display: none" />
    <confirmation-dialog ref="confirmationDialog" />
  </div>
</template>


<script>
  import Axios from "axios";
  export default {
    props: {
      item: Object,
      label: String,
      mediaItemProp: String,
      onMediaItemChange: Function,
      editItem: Function,
      deleteWholeItemTt: String,
      editTt: String,
      changeMediaTt: String,
      deleteMediaTt: String,
      controller:String
    },
    data() {
      return {
        showImage: true,
        ctrl:this.get_controller(this.controller)
      };
    },
    mounted() {},
    methods: {
      openfileTitleDialog() {
        let self = this;
        self.$refs.FileBackGround.value = null;
        self.$refs.FileBackGround.click();
      },
      
      deleteIMG(callback) {
        let self = this;
        self.showImage = false;
        self
          .delete("SystemMedia?Id=" + self.item[self.mediaItemProp])
          .then((r) => {
            self.item[self.mediaItemProp] = 0;
            self.ctrl.updateSection(self.item);
            self.showImage = true;
            if (callback != undefined) {
              callback();
            }
            console.log(r);
          });
      },
      getMediaItem() {
        let self = this;
        console.log("getmediaitem", self.item);
        return (
          process.env.VUE_APP_API +
          "SystemMedia?id=" +
          self.item[self.mediaItemProp]
        );
      },
      uploadtitleImage(e) {
        let self = this;
        let file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        let token = localStorage.getItem("access_token");
        Axios.defaults.headers.common["Authorization"] = "bearer " + token;
        self.showImage = false;
        console.log(self.item[self.mediaItemProp]);

        if (
          self.item[self.mediaItemProp] == 0 ||
          self.item[self.mediaItemProp] == null ||
          self.item[self.mediaItemProp] == undefined
        ) {
          Axios.post(
            process.env.VUE_APP_API + "SystemMedia",
            formData,
            config
          ).then((r) => {
            console.log(r);
            self.item[self.mediaItemProp] = r.data.data.id;
            self.ctrl.updateSection(self.item);
            self.showImage = true;
          });
        } else {
          console.log("[UPDATE IMAGE]");
          Axios.put(
            process.env.VUE_APP_API +
            "SystemMedia?Id=" +
            self.item[self.mediaItemProp],
            formData,
            config
          ).then((r) => {
            console.log(r);
            self.item[self.mediaItemProp] = r.data.data.id;
            self.ctrl.updateSection(self.item);
            self.showImage = true;
          });
        }
      },
    },
  };
</script>

<style scoped>
  #card {
    width: 100%;
    background: #efefef;
    border-radius: 30px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    display: grid;
    grid-template-columns: 75% 25%;
  }

  #sub-card {
    min-height: 250px;
    width: 100%;
    background: #51cae9;
    border-radius: 30px;
    box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.15);
    position: relative;
    text-align: center;
  }

  #image {
    width: 60%;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  #sub-card-content {
    height: 40%;
    width: 100%;
    background: rgba(26, 48, 54, 0.6);
    border-radius: 0px 0px 30px 30px;
    position: absolute;
    bottom: 0px;
    font-family: sans-serif;
    text-align: left;
    backdrop-filter: blur(2px);
  }

  #heading {
    font-size: 20px;
    padding: 15px;
    line-height: 20px;
    padding-bottom: 5px;
    color: white;
  }

  #subheading {
    font-size: 12px;
    line-height: 12px;
    padding: 15px;
    padding-top: 5px;
    padding-bottom: 15px;
    color: white;
  }

  #progress {
    height: 28px;
    margin-top: 10px;
    margin: 0px 15px;
    padding-bottom: 0px;
    background: #20505d;
    border-radius: 15px;
    position: relative;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  }

  #progress-bar {
    background: #51cae9;
    height: 18px;
    width: 25%;
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 5px;
    position: absolute;
    border-radius: 15px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  }

  #card-actions {
    padding-top: 20px;
  }

  .card-action {
    height: 40px;
    width: 40px;
    background: #51cae9;
    margin: 0 auto;
    margin-bottom: 20px;
    border-radius: 50%;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .card-action:hover {
    background: #3ac1e2;
    box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.15);
  }

  .card-action:active {
    background: #2e97b1;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
  }

  .card-icon {
    margin-top: 5px;
  }
</style>